import { Paper } from "@components/paper";
import LivingSituation from "./livingSituationForm";
import React from "react";
import { withLoanForm } from "../withLoanForm";
import ContentWrapper from "@components/contentWrapper";
import { MarginLeftRow, PaddingLeftCol } from "@components/leftGrid";

const _LivingSituationFormWrap = props => {
  const {title, ...rest} = props;
  return (
    <Paper $padding={0}>
      <ContentWrapper paddingTop="0">
        <MarginLeftRow>
          <PaddingLeftCol>
            <LivingSituation {...rest} />
          </PaddingLeftCol>
        </MarginLeftRow>
      </ContentWrapper>
    </Paper>
  );
};

// export default withLoanForm(LivingSituationFormWrap);
export const LivingSituationFormWrap =  withLoanForm(_LivingSituationFormWrap);